<template>
  <router-view
    v-slot="{ Component }"
  >
    <component
      :is="Component"
      @loading="$emit('loading', $event)"
    />
  </router-view>
</template>

<script>
export default {
  name: 'my-account-layout',
  inheritAttrs: false,
  emits: ['loading']
};
</script>
